import { ForwardRefExoticComponent, RefAttributes } from 'react';

import {
  Icon,
  IconChartBar,
  IconMail,
  IconProps,
  IconUsers,
  IconUserShield,
} from '@tabler/icons-react';

import { UserRole } from '@interfaces/users.interface';

export const linksData: {
  label: string;
  icon: ForwardRefExoticComponent<Omit<IconProps, 'ref'> & RefAttributes<Icon>>;
  link: string;
  roles?: UserRole[];
}[] = [
  {
    label: 'Clienti',
    icon: IconUsers,
    link: '/clienti',
    roles: ['admin'],
  },
  {
    label: 'Amministratori',
    icon: IconUserShield,
    link: '/amministratori',
    roles: ['admin'],
  },
  {
    label: 'Statistiche ricerche',
    icon: IconChartBar,
    link: '/statistiche-ricerche',
    roles: ['admin'],
  },
  {
    label: 'Impostazioni email',
    icon: IconMail,
    link: '/impostazioni-email',
    roles: ['admin'],
  },
];
